module App.Classes {
    export class Discount implements Interfaces.IDiscount {
        code: string;
        description: string;
    }
}